import RegisterFooter from './register-footer-container';

export default RegisterFooter;
